import Tables from 'src/class/Tables';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';

const configTable = () => {
  const Table = { ...Tables.Table };

  Table.tableColumns = [
    {
      prop: 'fortnight_name',
      label: i18n.t('labor.payment_frequency'),
      sortable: true,
      minWidth: 200,
    },
    {
      prop: 'worker_code',
      label: i18n.t('labor.worker_code'),
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'worker_name',
      label: `${i18n.t('common_words.name')} ${i18n.t('labor.worker')}`,
      sortable: true,
      minWidth: 200,
    },
    {
      prop: 'farm_name',
      label: i18n.t('common_words.farm'),
      sortable: true,
      minWidth: 200,
    },
    {
      prop: 'bonus_homologated_code',
      label: i18n.t('common_words.code_sap'),
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'days',
      label: `${i18n.t('common_words.working_days')}`,
      align: 'center',
      minWidth: 180,
      sortable: true,
    },
    {
      prop: 'bonus_value',
      label: i18n.t('common_words.value'),
      minWidth: 180,
      align: 'center',
      formatter: (row, column) => {
        return `$${Formatter.formatNumber(Number(row[column.property]))}`;
      },
    },
    {
      prop: 'total_value',
      label: i18n.t('common_words.total'),
      minWidth: 180,
      align: 'center',
      formatter: (row, column) => {
        return `$${Formatter.formatNumber(Number(row[column.property]))}`;
      },
    },
  ];

  return { Table };
};

export default configTable;
